declare namespace $ {

	export class $shm_textarea_code_line extends $mol_text_code_line {
	}
	
}

//# sourceMappingURL=line.view.tree.d.ts.map